import { render, staticRenderFns } from "./ReasonCard.vue?vue&type=template&id=d1f8f5ae"
import script from "./ReasonCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReasonCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/css/ai-streaming.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/scss/yagiprime/reason-card.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports